//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  required, minLength,
} from 'vuelidate/lib/validators';
import ValidationMixin from '../../../../common/form/mixins/ValidationMixin';

export default {
  name: 'MemberPassword',
  mixins: [ValidationMixin],
  props: {
    value: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      default: 'Password',
    },
  },
  validations: {
    value: {
      required,
      minLength: minLength(8),
      capital: value => (/[A-Z]+/).test(value),
      lower: value => (/[a-z]+/).test(value),
      number: value => (/[0-9]+/).test(value),             
      symbol: value => (/[#@!$%^&*()_|~`{}\[\]:";'<>?,.\/]+/).test(value)
    },
  },
  methods: {
    getErrors() {
      const errors = [];
      if (!this.$v.value.minLength || !this.$v.value.required) {
        errors.push('Password must be at least 8 characters');
      }
      if (!this.$v.value.symbol) {
        errors.push("Password must have at least 1 of the following symbols ^ $ * . [ ] { } ( ) ? \" ! @ # % & / \ , > < ' : ; | _ ~ `");
      }
      if (!this.$v.value.capital || !this.$v.value.lower) {
        errors.push('Password must have at least 1 upper and 1 lower case character');
      }
      if (!this.$v.value.number) {
        errors.push('Password must have at least 1 number');
      }
      return errors;
    },
  },
};
